<div class="exit-subscription-modal" [attr.inert]="isOpen ? null : ''">
  <ds-modal-bottom-sheet
    [visible]="isOpen"
    [title]="texts.title"
    [description]="texts.description"
    [showIcon]="true"
    iconName="WarningFill"
    iconColor="var(--ds-foundation-colors-color-orange-300)"
    [maxWidth]="modalWidth"
    (dismissed)="stay.emit()"
  >
    <div ds-modal-bottom-sheet-action>
      <ds-button-v2
        emphasis="primary"
        size="m"
        [fullWidth]="true"
        maxWidth="100%"
        [label]="texts.stayButton"
        (clicked)="stay.emit()"
      ></ds-button-v2>
      <ds-button-v2
        emphasis="secondary-outlined"
        size="m"
        [fullWidth]="true"
        maxWidth="100%"
        [label]="texts.leaveButton"
        (clicked)="leave.emit()"
      ></ds-button-v2>
    </div>
  </ds-modal-bottom-sheet>
</div>
